// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__QKaY3","alertIcon":"ConfirmModal_alertIcon__IwhAS"};